var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomChartDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#212632"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75583 15.1755L9.75708 15.1764C9.90404 15.2743 10.0957 15.2745 10.2427 15.1765L9.98792 15.2498L10.2432 15.1761L10.2442 15.1755L10.2471 15.1736L10.2571 15.1668L10.2933 15.1419C10.3244 15.1204 10.369 15.0891 10.4253 15.0484C10.5379 14.9671 10.6972 14.8485 10.8878 14.6967C11.2682 14.3938 11.7765 13.9562 12.2864 13.4181C13.2881 12.3606 14.375 10.8321 14.375 9.125C14.375 7.96468 13.9141 6.85188 13.0936 6.03141C12.2731 5.21094 11.1603 4.75 10 4.75C8.83968 4.75 7.72688 5.21094 6.90641 6.03141C6.08594 6.85188 5.625 7.96468 5.625 9.125C5.625 10.8321 6.71186 12.3606 7.71365 13.4181C8.22348 13.9562 8.73183 14.3938 9.11224 14.6967C9.30278 14.8485 9.46211 14.9671 9.57466 15.0484C9.63095 15.0891 9.67561 15.1204 9.70668 15.1419L9.74289 15.1668L9.75292 15.1736L9.75583 15.1755ZM8.6875 9.125C8.6875 8.40013 9.27513 7.8125 10 7.8125C10.7249 7.8125 11.3125 8.40013 11.3125 9.125C11.3125 9.84987 10.7249 10.4375 10 10.4375C9.27513 10.4375 8.6875 9.84987 8.6875 9.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomChartDot);
export default __webpack_public_path__ + "static/media/customChartDot.2b9e75e87f7e82febc27936791d6f60d.svg";
export { ForwardRef as ReactComponent };